import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';

import { backendClient as client } from './clients';
import { ActivityBulkDTO, BulkActionPermissionDTO } from './dto';
import { CreateOne, GetManyPagedWithParam } from './types';
export const BULK_PATH = 'bulk';

export const getActivitiesWithPermission: GetManyPagedWithParam<{ bulkActionType: string }, ActivityBulkDTO> = ({
    filter,
    page = 0,
    size,
    sort,
    config,
    bulkActionType,
}) =>
    client
        .get(buildPath([BULK_PATH, 'activity', bulkActionType]), { ...config, params: { filter, page, size, sort } })
        .then((response) => response.data);

export const getActivitiesPermissions: CreateOne<
    { bulkActionType: string; ids: Array<string | number> },
    BulkActionPermissionDTO[]
> = ({ ids, bulkActionType, config }) =>
    client
        .post(buildPath([BULK_PATH, 'activity', 'permissions', bulkActionType]), ids, config)
        .then((response) => response.data);

export const bulkActivityResume: CreateOne<{ ids: Array<string | number> }, number> = async ({ ids, config }) =>
    client
        .post(buildPath([BULK_PATH, 'activity', 'resume']), ids, config)
        .then((response: AxiosResponse) => response.data);

export const bulkActivityInterrupt: CreateOne<{ ids: Array<string | number> }, number> = async ({ ids, config }) =>
    client
        .post(buildPath([BULK_PATH, 'activity', 'interrupt']), ids, config)
        .then((response: AxiosResponse) => response.data);

export const bulkActivityClose: CreateOne<{ ids: Array<string | number> }, number> = async ({ ids, config }) =>
    client
        .post(buildPath([BULK_PATH, 'activity', 'close']), ids, config)
        .then((response: AxiosResponse) => response.data);

export const bulkActivityTag: CreateOne<{ ids: Array<string | number>; tagName: string }, number> = async ({
    ids,
    tagName,
    config,
}) =>
    client
        .post(buildPath([BULK_PATH, 'activity', 'tag', tagName]), ids, config)
        .then((response: AxiosResponse) => response.data);
